import { cn } from "@/lib/utils"
import { Separator } from "@ui/separator"

interface PageFooterProps {
  className?: string
  showSeparator?: boolean
  children?: React.ReactNode
  sticky?: boolean
}

export function PageFooter({
  className,
  showSeparator = false,
  children,
  sticky = false,
}: PageFooterProps) {
  return (
    <>
      {showSeparator && <Separator />}
      <footer
        className={cn(
          "text-muted-foreground bg-card/30 px-6 py-4 text-center text-sm",
          sticky && "sticky bottom-0",
          className
        )}
      >
        {children || (
          <span>&copy; {new Date().getFullYear()} Speeke. Todos os direitos reservados.</span>
        )}
      </footer>
    </>
  )
}
